import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import uniqBy from "lodash/uniqBy";
import {injectIntl} from "react-intl";

import RowItem from "./rowItem";
import {createRelatedGroups, getFilteredRelatedFeatures, getRelatedFeaturesFromLayout} from "../../../misc/helpers";
import {getBvFeatures} from "../../../api/server-api";
import {getCurrentLayout} from "../../appLayout";
import LoadingSpinner from "../../ui/loadingSpinner";


const RowItemRelatedProducts = (props) => {

  const {relatedFeatures, updateVirtualizedCache, intl, fabricatorData, activeQuoteIndex, windowWidth, currentFeature} = props;
  const [relatedFeaturesRequestMade, setRelatedFeaturesRequestMade] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [relGroups, setRelGroups] = useState([]);

  const getLoadedFeatures = () => {
    let {noFeaturesFound, relatedFeaturesFound} = getRelatedFeaturesFromLayout(relatedFeatures, currentFeature);
    if (noFeaturesFound.length && !relatedFeaturesRequestMade) {
      setIsLoading(true);
      getBvFeatures(noFeaturesFound)
        .then(response => {
          const layout = getCurrentLayout();
          layout.loadNewFeatures(response.data);
          setRelatedFeaturesRequestMade(true);
          setIsLoading(false);
          // this.setRelatedGroups(this.props);
        });
    }
    relatedFeaturesFound = getFilteredRelatedFeatures(relatedFeaturesFound);
    return uniqBy(relatedFeaturesFound, (feature) => feature.dbFeature.id)
  };

  useEffect(() => {
    const loadedFeatures = getLoadedFeatures();
    const groups = createRelatedGroups(loadedFeatures, [], activeQuoteIndex, intl, fabricatorData);
    setRelGroups(groups);
    updateVirtualizedCache();
    setTimeout(() => {
      updateVirtualizedCache();
    }, 0)
    return () => {
      updateVirtualizedCache();
      setTimeout(() => {
        updateVirtualizedCache();
      }, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  const handleFeatureClick = () => {};

  const featureHeight = windowWidth < 991 ? 125 : 155;  // css height + 15

  const relatedStyles = {
    height: relGroups.length && !isLoading
      ? relGroups.reduce((acc, group) => acc + 40 + (group.relatedFeatures.length * featureHeight), 0) // 25 is associated-title
      : featureHeight
  }

  return (
    <div className="m-related" style={relatedStyles}>
      {isLoading ? <LoadingSpinner/> : relGroups.map((relatedGroup, relatedGroupIndex) => {
        return (
          <li className="associated" key={relatedGroupIndex}>
            <h4 className="associated-title">{relatedGroup.name}</h4>
            {relatedGroup.relatedFeatures.map((relatedFeature, relatedFeatureIndex) => {
              return (
                <div className="m-feature" key={relatedFeatureIndex + relatedFeature.dbFeature.id}>
                  <RowItem selected={false}
                           isRelated={true}
                           currentFeature={relatedFeature}
                           handleFeatureClick={handleFeatureClick}/>
                </div>
              )
            })}
          </li>
        )
      })}
    </div>
  )
};

RowItemRelatedProducts.propTypes = {
  currentFeature: PropTypes.object.isRequired,
  relatedFeatures: PropTypes.array.isRequired,
  updateVirtualizedCache: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    windowWidth: store.serverState.windowWidth,
  };
};

const mapDispatchToProps = {}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RowItemRelatedProducts)
);
